import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import uuidv1 from 'uuid/v1'
import {DatePicker, Progress} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ViewUI from 'view-design';
import publicFun from './plugins/publiction.js'
import Message from '@/plugins/message.js'
import hevueImgPreview from '@/plugins/preview/index'

import 'view-design/dist/styles/iview.css';

import CheckBox from '@/components/CheckBox.vue';
import Loading from '@/components/Loading.vue'
import CheckIcon from '@/components/CheckIcon.vue'
import DialogBox from '@/components/DialogBox.vue'

import '@/assets/css/reset.css';
import '@/assets/css/publication.css';
import '@/assets/css/icon/iconfont.css';


Vue.use(ViewUI);
// import 'babel-polyfill'
Vue.use(hevueImgPreview)




Vue.config.productionTip = false
Vue.prototype.ceshi = '1fgfg51sad'
Vue.prototype.$uuidv1 = uuidv1
Vue.prototype.$message = Message

Vue.directive('focus', {  //自动获取焦点并全选
  inserted: function (el) {
    el.focus()
    el.select()
  }
})

Vue.use(publicFun)
Vue.component('dialog-box', DialogBox)
Vue.component('check-box', CheckBox)
Vue.component('loading', Loading)
Vue.component('check-icon', CheckIcon)
Vue.component(DatePicker.name, DatePicker);
Vue.component(Progress.name, Progress);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// import Vconsole from 'vconsole';
//
// let vConsole = new Vconsole();
//
// export default vConsole

